export const faqs = [
  {
    question: 'What is SwiftMedix for merchants?',
    answer:
      'SwiftMedix helps verified pharmacies and health stores sell products online, reach more customers, and manage their stores from one dashboard.',
  },
  {
    question: 'How do I join SwiftMedix?',
    answer:
      'Sign up, submit your business documents (registration, licenses), and get access to your merchant dashboard once approved.',
  },
  {
    question: 'What products can I sell?',
    answer:
      'You can sell over-the-counter medicines, supplements, wellness items, contraceptives, and medical supplies. Prescription products may need extra verification.',
  },
  {
    question: 'How do payments work?',
    answer:
      'Customers pay via cards, mobile wallets, or other supported methods. SwiftMedix initiates payouts (minus charges) to your bank account on a regular schedule.',
  },
  {
    question: 'How do I fulfill orders?',
    answer:
      'Once an order is placed, simply prepare and package the product. A logistics partner will pick it up directly from your store and deliver it to the customer.',
  },
  {
    question: 'How should I list my products?',
    answer:
      'Use clear names, descriptions, prices, and good-quality images. Include necessary details like expiration dates or batch numbers. Only list authentic, high-quality products.',
  },
  {
    question: 'How are returns, refunds, and complaints handled?',
    answer:
      'Follow SwiftMedix’s return policy. You’ll be notified of complaints and expected to respond. Refunds or replacements follow platform guidelines.',
  },
  {
    question: 'How can I track sales and run promotions?',
    answer:
      'Your dashboard shows orders, sales, returns, and performance insights. You can also run discounts or bundle deals within SwiftMedix’s rules.',
  },
];
